// @flow
import ColorFlipper from './component';
import { connect } from 'react-redux';
import { flowRight } from 'lodash/fp';
import { fromJS } from 'immutable';
import { getIsGroupForProduct } from '~/core/state/products/selectors';
import { withRouter } from 'react-router-dom';

const calculateFactors = (items, totalAngle = Math.PI * 1.5 /*270°*/) =>
    items.map(({ r, value }, index) => {
        const angle = index * totalAngle / (items.length - 1);
        return {
            r,
            rScale: (index + 1) / items.length,
            value,
            xFactor: -Math.cos(angle),
            yFactor: -Math.sin(angle)
        };
    });

const calculateFactorsImmutable = flowRight(fromJS, calculateFactors);

const mapStateToProps = (state, { items, match }): { items: *, isGroup: boolean } => {
    const { params: { id } } = match;

    return {
        items: calculateFactorsImmutable(items),
        isGroup: getIsGroupForProduct(state, { id })
    };
};

export default withRouter(connect(mapStateToProps)(ColorFlipper));



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/brightness-flipper/index.js